export { RoutePaths, ApplicationRoutes } from './appRoutes';

export const APP_NAME = 'prompthub';

export const RULES_NEW_URL = 'https://lpc-ext.s3.yandex.net/ai-platform/legal/Промптхаб_лучшее_171125.pdf';
export const RULES_COMPETE_URL =
    'https://lpc-ext.s3.yandex.net/ai-platform/legal/Условия_конкурса_ИИ_челленджи_на_промптхабе_171125.pdf';

export const CONDITIONS_URL = 'https://yandex.ru/legal/prompthub/ru/';
export const PRIVACY_POLICY_URL = 'https://yandex.ru/legal/confidential/ru/';
export const TELEGRAM_CHANNEL_URL = 'https://t.me/prompthub_yndx';
